'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TagPickerButton", {
    enumerable: true,
    get: function() {
        return TagPickerButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTagPickerButton = require("./useTagPickerButton");
const _renderTagPickerButton = require("./renderTagPickerButton");
const _useTagPickerButtonStylesstyles = require("./useTagPickerButtonStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TagPickerButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTagPickerButton.useTagPickerButton_unstable)(props, ref);
    (0, _useTagPickerButtonStylesstyles.useTagPickerButtonStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTagPickerButtonStyles_unstable')(state);
    return (0, _renderTagPickerButton.renderTagPickerButton_unstable)(state);
});
TagPickerButton.displayName = 'TagPickerButton';
